export const wpFAQClass = 'schema-faq';
export const wpFAQSectionClass = 'schema-faq-section';
export const wpFAQQuestionClass = 'schema-faq-question';
export const wpFAQAnswerClass = 'schema-faq-answer';

export const testAttributes = {
    FAQ_ACCORDION_TITLE: 'faq-accordion-title',
    FAQ_ACCORDION_CONTENT: 'faq-accordion-content',
    FAQ_ACCORDION_CARD_CONTAINER: 'faq-accordion-card-container',
};
